module.exports = __webpack_public_path__ + "img/Tajikistan.0b87093b.svg";